<template>
  <v-card outlined rounded :loading="loading">
    <v-card-text class="pa-10">
      <div class="d-flex justify-space-between">
        <div class="d-flex flex-column">
          <h2>{{ $t('Push notifications') }}</h2>
          <p class="grey--text text-body-1 text--grey darken-1 mb-6 mt-2">
            {{ $t('push-notification-description') }}
          </p>
        </div>
        <div>
          <v-switch
            class="mt-0"
            v-model="hasPushPermission"
            @change="toggleNotifications"
          />
        </div>
      </div>
    </v-card-text>

    <v-dialog
      v-model="showConfirmModal"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          {{ hasPushPermission ? $t('Enable push notifications') : $t('Disable push notifications') }}?
        </v-card-title>
        <v-card-text>
          {{ hasPushPermission
            ? $t('push-permission-enable-info')
            : $t('push-permission-disable-info')
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancelToggleNotifications"
          >{{$t('Cancel')}}</v-btn>
          <v-btn
            color="primary"
            @click="confirmToggleNotifications"
          >{{$t('Confirm')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showPushPermissionUpdatedModal"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t(`Push notifications ${hasPushPermission ? 'enabled' : 'disabled'}`) }}
        </v-card-title>
        <v-card-text>{{ pushPermissionUpdatedModalMessage }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="showPushPermissionUpdatedModal = false"
          >{{$t('OK')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'Notifications',
  components: {
  },
  data() {
    return {
      hasPushPermission: false,
      showConfirmModal: false,
      showPushPermissionUpdatedModal: false,
      pushPermissionUpdatedModalMessage: '',
    };
  },
  mounted() {
    this.checkCordovaPushPermission();
    if (window.isUsingApp) {
      window.addEventListener('message', this.handleMessageFromCordova);
    }
  },
  destroyed() {
    if (window.isUsingApp) {
      window.removeEventListener('message', this.handleMessageFromCordova);
    }
  },
  methods: {
    checkCordovaPushPermission() {
      if (window.cordova_iab) {
        window.cordova_iab.postMessage(JSON.stringify({ type: 'check-push-permission' }));
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.cordova_iab) {
        window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ type: 'check-push-permission' }));
      }
    },
    handleMessageFromCordova(event) {
      const eventData = JSON.parse(event.data);
      if (eventData && eventData.type) {
        if (eventData.type === 'cordova-push-permission-response' && 'enabled' in eventData) {
          this.hasPushPermission = eventData.enabled;
        }
        if (eventData.type === 'cordova-push-permission-updated' && 'message' in eventData) {
          this.showPushPermissionUpdatedModal = true;
          this.pushPermissionUpdatedModalMessage = this.$t(eventData.message);
        }
      }
    },
    toggleNotifications() {
      this.showConfirmModal = true;
    },
    confirmToggleNotifications() {
      this.showConfirmModal = false;
      if (window.cordova_iab) {
        window.cordova_iab.postMessage(JSON.stringify({ type: 'toggle-push-permission', enabled: this.hasPushPermission }));
      } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.cordova_iab) {
        window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify({ type: 'toggle-push-permission', enabled: this.hasPushPermission }));
      }
    },
    cancelToggleNotifications() {
      this.showConfirmModal = false;
      this.hasPushPermission = !this.hasPushPermission;
    },
  },
};
</script>
